import script from "./KolRecommend.vue?vue&type=script&setup=true&lang=js"
export * from "./KolRecommend.vue?vue&type=script&setup=true&lang=js"

import "./KolRecommend.vue?vue&type=style&index=0&id=637b48d3&lang=scss&scoped=true"

import exportComponent from "/Users/rioschan/Downloads/event-2022electrolux-main/vue-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-637b48d3"]])

export default __exports__